import { render, staticRenderFns } from "./MallDetail.vue?vue&type=template&id=37e1dd6a&scoped=true&"
import script from "./MallDetail.vue?vue&type=script&lang=js&"
export * from "./MallDetail.vue?vue&type=script&lang=js&"
import style0 from "./MallDetail.vue?vue&type=style&index=0&id=37e1dd6a&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37e1dd6a",
  null
  
)

export default component.exports